module.exports = __webpack_public_path__ + "img/tg(white).98d3dd3a.svg";